import { Container, Title, Button } from '@/components'

import styles from './styles.module.scss'
import { TRAININGS } from './constants'
import Image from 'next/image'
import useClickWithScroll from '@/utils/browser/useClickWithScroll'

const TypesTrainings = ({
  description = 'Treinos adaptáveis para todos os níveis e objetivos: seja emagrecimento, ganho de massa ou mobilidade.',
  smallDisclaimer = '',
  variant,
  buttonColor,
  buttonTextVariant,
  buttonText = 'QUERO COMEÇAR AGORA'
}) => {
  const { isHomePage, onClickItem } = useClickWithScroll()

  return (
    <section className={`fgt-section ${styles.trainings} ${styles[variant]} `}>
      <Container>
        <Title Tag="h2" alignText="center" colorText="light">
          Treinos para <span>todos os níveis</span> que combinam com você
        </Title>
        <p className="fgt-subtitle fgt-subtitle--light">{description}</p>

        <div className={styles.trainings__types}>
          {TRAININGS.map((item, index) => {
            return (
              <div className={styles.trainings__item} key={index}>
                <Image
                  className={styles['trainings__item--image']}
                  src={item.imageUrl}
                  alt={item.alt}
                  width={340}
                  height={425}
                />
              </div>
            )
          })}
        </div>

        <p className={styles.smallDisclaimer}>{smallDisclaimer}</p>

        <div
          className={`${variant === 'anniversary' ? `${styles.button}` : 'fgt-section__action'}`}
        >
          <Button
            id="btn-section-trainings-types"
            variant={buttonColor || 'primary'}
            textVariant={buttonTextVariant}
            className={'fgt-section__action--button'}
            onClick={() => {
              onClickItem('comparePlans')
            }}
          >
            {buttonText}
          </Button>
        </div>
      </Container>
    </section>
  )
}

export default TypesTrainings
